import {AlignmentType, BorderStyle, convertInchesToTwip, Paragraph, TableCell, TextRun, VerticalAlign, WidthType, ImageRun} from "docx";
import {paragraphArial, paragraphArialBold} from "./paragraphs";
import {ekboImage} from "../../../images/ekbo";
const factor = 0.2;

export const tableCellHeaderBold = text => {
  return new TableCell({
    borders: {
      top: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
      bottom: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
      left: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
      right: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"}
    },
    width: {size: 20, type: WidthType.AUTO},
    children: [
      new Paragraph({
        children: [
          new TextRun({
            text,
            bold: true,
            font: "Arial"
          })
        ]
      })
    ]
  });
};
export const tableCellHeader = text => {
  return new TableCell({
    borders: {
      top: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
      bottom: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
      left: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
      right: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"}
    },
    width: {size: 20, type: WidthType.AUTO},
    children: [
      new Paragraph({
        children: [
          new TextRun({
            text,
            font: "Arial"
          })
        ]
      })
    ]
  });
};
export const tableCellHeaderHeadline = text => {
  return new TableCell({
    borders: {
      top: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
      bottom: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
      left: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
      right: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"}
    },
    width: {size: 20, type: WidthType.AUTO},
    children: [
      new Paragraph({
        children: [
          new TextRun({
            text,
            font: "Arial",
            size: 25
          })
        ]
      })
    ]
  });
};
export const tableCellHeaderColspan = (text, colspan) => {
  return new TableCell({
    borders: {
      top: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
      bottom: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
      left: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
      right: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"}
    },
    columnSpan: colspan,
    width: {size: 20, type: WidthType.AUTO},
    children: [
      new Paragraph({
        children: [
          new TextRun({
            text,
            font: "Arial"
          })
        ]
      })
    ]
  });
};

export const tableCellMain = text => {
  return new TableCell({
    margins: {
      top: convertInchesToTwip(0.05),
      bottom: convertInchesToTwip(0.05),
      left: convertInchesToTwip(0.05),
      right: convertInchesToTwip(0.05)
    },
    width: {size: 20, type: WidthType.AUTO},
    children: [
      new Paragraph({
        children: [
          new TextRun({
            text,
            font: "Arial"
          })
        ]
      })
    ]
  });
};
export const tableCellMainCenter = text => {
  return new TableCell({
    alignment: AlignmentType.CENTER,
    margins: {
      top: convertInchesToTwip(0.05),
      bottom: convertInchesToTwip(0.05),
      left: convertInchesToTwip(0.05),
      right: convertInchesToTwip(0.05)
    },
    width: {size: 20, type: WidthType.AUTO},
    children: [
      new Paragraph({
        children: [
          new TextRun({
            text,
            font: "Arial"
          })
        ]
      })
    ]
  });
};
export const tableCellMainRight = text => {
  return new TableCell({
    margins: {
      top: convertInchesToTwip(0.05),
      bottom: convertInchesToTwip(0.05),
      left: convertInchesToTwip(0.05),
      right: convertInchesToTwip(0.05)
    },
    width: {size: 20, type: WidthType.AUTO},
    children: [
      new Paragraph({
        alignment: AlignmentType.RIGHT,
        children: [
          new TextRun({
            text,
            font: "Arial"
          })
        ]
      })
    ]
  });
};
export const tableCellWithTextArray = textArray => {
  console.log({textArray});
  return new TableCell({
    margins: {
      top: convertInchesToTwip(0.05),
      bottom: convertInchesToTwip(0.05),
      left: convertInchesToTwip(0.05),
      right: convertInchesToTwip(0.05)
    },
    width: {size: 20, type: WidthType.AUTO},
    children: [...textArray.map(t => new Paragraph(t))]
  });
};

export const tableCellWithTextArrayExpanded = (textArray, remarks = "") => {
  console.log({textArray});
  let children = [...textArray.map(t => paragraphArial(t))];
  if (remarks !== "") children = [...children, paragraphArialBold("Bemerkungen"), paragraphArial(remarks)];
  return new TableCell({
    margins: {
      top: convertInchesToTwip(0.05),
      bottom: convertInchesToTwip(0.05),
      left: convertInchesToTwip(0.05),
      right: convertInchesToTwip(0.05)
    },
    width: {size: 20, type: WidthType.AUTO},
    children
  });
};

export const tableCellWithColSpan = (text, colspan) => {
  return new TableCell({
    margins: {
      top: convertInchesToTwip(0.05),
      bottom: convertInchesToTwip(0.05),
      left: convertInchesToTwip(0.05),
      right: convertInchesToTwip(0.05)
    },
    width: {size: 20, type: WidthType.AUTO},
    columnSpan: colspan,
    children: [
      new Paragraph({
        children: [
          new TextRun({
            text,
            font: "Arial"
          })
        ]
      })
    ]
  });
};
export const tableCellWithRowSpan = (text, rowspan) => {
  return new TableCell({
    borders: {
      top: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
      bottom: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
      left: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
      right: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"}
    },
    width: {size: 20, type: WidthType.AUTO},
    rowSpan: rowspan,
    children: [
      new Paragraph({
        children: [
          new TextRun({
            text,
            font: "Arial"
          })
        ]
      })
    ]
  });
};
export const tableCellWithRowSpanAndImage = (text, rowspan, logo) => {
  console.log({logo});
  const {height, width, imageBuffer} = logo;
  return new TableCell({
    borders: {
      top: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
      bottom: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
      left: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"},
      right: {style: BorderStyle.NONE, size: 0, color: "FFFFFF"}
    },
    width: {size: 20, type: WidthType.AUTO},
    rowSpan: rowspan,
    children: [
      new Paragraph({
        alignment: AlignmentType.RIGHT,

        // alignment: AlignmentType.END,
        children: [
          new TextRun(" "),
          new ImageRun({
            verticalAlign: VerticalAlign.TOP,
            data: imageBuffer,
            transformation: {
              width: width * factor,
              height: height * factor
            }
          })
          // Media.addImage(doc, imageBuffer, width, height, {
          //   floating: {
          //     behindDocument: false,
          //     margins: { top: 0, bottom: 0, left: 0, right: 0 },
          //   },
          // }),
        ]
      })
    ]
  });
};
export const tableCellWithRowSpanBorders = (text, rowspan) => {
  return new TableCell({
    verticalAlign: VerticalAlign.CENTER,
    width: {size: 20, type: WidthType.AUTO},
    rowSpan: rowspan,
    children: [
      new Paragraph({
        alignment: AlignmentType.CENTER,
        children: [
          new TextRun({
            size: 30,
            text,
            font: "Arial"
          })
        ]
      })
    ]
  });
};
